module.exports = __webpack_public_path__ + "img/75730.c217c507.svg";